import { render, staticRenderFns } from "./BusinessCardForm.vue?vue&type=template&id=2d597f0c&"
import script from "./BusinessCardForm.vue?vue&type=script&lang=ts&"
export * from "./BusinessCardForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports